import React from 'react';

function LinkedInIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      fill="none"
      viewBox="0 0 14 14"
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M1.033 0h11.93C13.533 0 14 .452 14 1.009V12.99C14 13.55 13.533 14 12.963 14H1.033A1.02 1.02 0 010 12.991V1.01A1.02 1.02 0 011.033 0zm.877 3.131a1.203 1.203 0 102.407 0 1.204 1.204 0 00-2.407 0zm7.944 8.8h2.074V8.263c0-1.8-.389-3.183-2.49-3.183-1.01 0-1.687.555-1.965 1.08h-.027V5.25H5.455v6.68h2.073V8.625c0-.872.165-1.715 1.246-1.715 1.065 0 1.08.997 1.08 1.772v3.248zm-7.78 0V5.25h2.079v6.68h-2.08z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default LinkedInIcon;
